const arg = (real: number, imag: number): number => Math.atan2(imag, real);

export default arg;
